import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { API, errMsg } from "../../lib/api";
import { Field, ErrBox } from "../../components/common";

export default function Consultation() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", business_name: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await API.post("/public/consultation", form);
      setDone(true);
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };

  if (done) return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center">
      <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" />
      <h1 className="mt-4 text-3xl font-bold text-navy" data-testid="consultation-success">Consultation Requested</h1>
      <p className="mt-3 text-slate-600">Thank you. A tax specialist will contact you shortly.</p>
    </div>
  );

  return (
    <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6">
      <div className="text-xs font-semibold uppercase tracking-widest text-copper">Book a Consultation</div>
      <h1 className="mt-2 text-4xl font-bold tracking-tight text-navy">Talk to a Tax Specialist</h1>
      <p className="mt-3 text-slate-600">Tell us about your business and we'll recommend the right level of tax management — from self-serve dashboard to full Autopilot.</p>
      <form onSubmit={submit} className="card-gov mt-8 space-y-4 p-6" data-testid="consultation-form">
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="Your Name *"><input className="input-gov" value={form.name} onChange={set("name")} required data-testid="consult-name" /></Field>
          <Field label="Email *"><input type="email" className="input-gov" value={form.email} onChange={set("email")} required data-testid="consult-email" /></Field>
          <Field label="Phone"><input className="input-gov" value={form.phone} onChange={set("phone")} data-testid="consult-phone" /></Field>
          <Field label="Business Name"><input className="input-gov" value={form.business_name} onChange={set("business_name")} data-testid="consult-business" /></Field>
        </div>
        <Field label="How can we help?"><textarea className="input-gov" rows={4} value={form.message} onChange={set("message")} data-testid="consult-message" /></Field>
        <ErrBox msg={err} />
        <button className="btn-navy w-full" disabled={busy} data-testid="consult-submit">{busy ? "Sending…" : "Request Consultation"}</button>
      </form>
    </div>
  );
}
